import {
  getAllGoodsTypeListApi,
  addGoodsTypeApi,
  getGoodsTypeByIdApi,
  updateGoodsTypeApi,
  setGoodsTypeApi,
  deleteGoodsTypeApi,
  getGoodsDetailsTemplateListApi,
  addGoodsDetailsTemplateApi,
  updateGoodsDetailsTemplateApi,
  getGoodsDetailsTemplateByIdApi,
  deleteGoodsDetailsTemplateApi,
  getGoodsTagListApi,
  addGoodsTagApi,
  deleteGoodsTagApi,
  addGoodsApi,
  updateGoodsApi,
  getGoodsDetailApi,
  getGoodsListApi,
  addGoodsPropertyAndItemApi,
  updateGoodsPropertyAndItemApi,
  addGoodsSkuApi,
  deleteGoodsPropertyItemApi,
  deleteGoodsPropertyApi,
  getGoodsPropertyAndItemAndSkuListApi,
  addGoodsRelationGroupApi,
  updateGoodsRelationGroupApi,
  getGoodsRelationGroupApi,
  deleteGoodsRelationGroupApi,
  addGoodsRelationConfigApi,
  updateGoodsRelationConfigApi,
  getGoodsRelationConfigDetailByIdApi,
  saveGoodsRelationConfigVipPriceApi,
  deleteGoodsRelationConfigApi,
  batchSetGoodsVirtualSalesNumApi,
  setGoodsIsShelvesApi,
  batchSetGoodsIsShelvesApi,
  batchSetGoodsSkuApi,
  setGoodsPicContentApi,
  queryGoodsApi,
  updateGoodsSkuApi,
  getShopCityListByBrandIdApi,
  queryShopApi,
  getGoodsRelationGroupAndConfigCountListApi,
  getGoodsRelationConfigDetailListApi,
  queryGoodsTagApi,
  queryGoodsDetailsTemplateApi,
  setGoodsTypeSortNumApi,
  saveSkuPicApi,
  updateGoodsIsShowedInDetailApi,
  setGoodsRelationConfigSortApi,
  getGoodsRelationGroupListApi,
  addGoodsRelationGroupRelApi,
  deleteGoodsRelationGroupRelApi,
  getGoodsDetailListApi,
  addGoodsTemplateApi,
  goodsTemplateQuoteApi,
  goodsTemplatePicQuoteApi,
  getBrandGoodsTemplateCountApi,
  queryGoodsTemplateApi,
  getGoodsTemplateByIdApi,
  deleteGoodsTemplateApi,
  queryGoodsListApi,
  addGoodsTemplateForSupplyApi,
  queryGoodsTemplateForSupplyApi,
  setGoodsTemplateIsShelvesApi,
  onekeyAgentSaleAddGoodsApi,
  getGoodsTemplateForSupplyByIdApi,
  updateGoodsTemplateForSupplyApi,
  updatePosterGoodsApi,
  getPosterGoodsApi,
  addShopGoodsTypeApi,
  getShopGoodsTypeListApi,
  addShopGoodsApi,
  updateShopGoodsApi,
  addShopGoodsSkuApi,
  updateShopGoodsSkuApi,
  addShopGoodsRelationConfigApi,
  updateShopGoodsRelationConfigApi,
  batchSetShopGoodsSkuApi,
  batchImportOutGoodsCodeApi,
  queryGoodsCodeApi,
  deleteGoodsCodeApi,
  setGoodsIsRecomApi,
  setGoodsLimitBuyRuleApi,
  getLimitBuyGoodsIdsApi,
  batchCopyShopGoodsApi,
  getGoodsTypeListApi,
  getGoodsByGoodsTypeIdApi
} from '@/api'
//   import { async } from 'q'
//   import { async } from 'q'
//   import { RES_OK } from '@/config'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  获取商品类型列表
  async getBoxGoodsTypeListAction(context, param) {
    const res = await getGoodsTypeListApi(param)
    return res
  },
  //  获取所有商品类型列表
  async getAllGoodsTypeListAction(context, param) {
    const res = await getAllGoodsTypeListApi(param)
    return res
  },
  //  添加商品类型信息
  async addGoodsTypeAction(context, param) {
    const res = await addGoodsTypeApi(param)
    return res
  },
  //    根据id获得商品类型信息
  async getGoodsTypeByIdAction(context, param) {
    const res = await getGoodsTypeByIdApi(param)
    return res
  },
  //    修改商品类型信息
  async updateGoodsTypeAction(context, param) {
    const res = await updateGoodsTypeApi(param)
    return res
  },
  //    设置商品类型信息(修改不空的)
  async setGoodsTypeAction(context, param) {
    const res = await setGoodsTypeApi(param)
    return res
  },
  //    删除商品类型信息
  async deleteGoodsTypeAction(context, param) {
    const res = await deleteGoodsTypeApi(param)
    return res
  },
  //    获取商品详情模板列表信息
  async getGoodsDetailsTemplateListAction(context, param) {
    const res = await getGoodsDetailsTemplateListApi(param)
    return res
  },
  //    添加商品详情模板信息
  async addGoodsDetailsTemplateAction(context, param) {
    const res = await addGoodsDetailsTemplateApi(param)
    return res
  },
  //    修改商品详情模板信息
  async updateGoodsDetailsTemplateAction(context, param) {
    const res = await updateGoodsDetailsTemplateApi(param)
    return res
  },
  //    根据id获得商品详情模板信息
  async getGoodsDetailsTemplateByIdAction(context, param) {
    const res = await getGoodsDetailsTemplateByIdApi(param)
    return res
  },
  //    删除商品详情模板信息
  async deleteGoodsDetailsTemplateAction(context, param) {
    const res = await deleteGoodsDetailsTemplateApi(param)
    return res
  },
  //    获取商品标签列表信息
  async getGoodsTagListAction(context, param) {
    const res = await getGoodsTagListApi(param)
    return res
  },
  //  添加商品标签
  async addGoodsTagAction(context, param) {
    const res = await addGoodsTagApi(param)
    return res
  },
  //  删除商品标签
  async deleteGoodsTagAction(context, param) {
    const res = await deleteGoodsTagApi(param)
    return res
  },
  //  添加商品信息
  async addGoodsAction(context, param) {
    const res = await addGoodsApi(param)
    return res
  },
  //  修改商品信息
  async updateGoodsAction(context, param) {
    const res = await updateGoodsApi(param)
    return res
  },
  //  获得商品详细信息
  async getGoodsDetailAction(context, param) {
    const res = await getGoodsDetailApi(param)
    return res
  },
  //  获取商品列表信息
  async getGoodsListAction(context, param) {
    const res = await getGoodsListApi(param)
    return res
  },
  //  添加商品属性和条目
  async addGoodsPropertyAndItemAction(context, param) {
    const res = await addGoodsPropertyAndItemApi(param)
    return res
  },
  //  更新商品属性和条目
  async updateGoodsPropertyAndItemAction(context, param) {
    const res = await updateGoodsPropertyAndItemApi(param)
    return res
  },
  //  添加商品sku信息
  async addGoodsSkuAction(context, param) {
    const res = await addGoodsSkuApi(param)
    return res
  },
  //  删除商品属性条目
  async deleteGoodsPropertyItemAction(context, param) {
    const res = await deleteGoodsPropertyItemApi(param)
    return res
  },
  //  删除商品属性信息
  async deleteGoodsPropertyAction(context, param) {
    const res = await deleteGoodsPropertyApi(param)
    return res
  },
  //  获取商品关联的属性和条目及sku相关信息列表
  async getGoodsPropertyAndItemAndSkuListAction(context, param) {
    const res = await getGoodsPropertyAndItemAndSkuListApi(param)
    return res
  },
  //  添加商品搭售分组
  async addGoodsRelationGroupAction(context, param) {
    const res = await addGoodsRelationGroupApi(param)
    return res
  },
  //  修改商品搭售分组
  async updateGoodsRelationGroupAction(context, param) {
    const res = await updateGoodsRelationGroupApi(param)
    return res
  },
  //  获取商品搭售分组
  async getGoodsRelationGroupAction(context, param) {
    const res = await getGoodsRelationGroupApi(param)
    return res
  },
  //  删除商品搭售分组
  async deleteGoodsRelationGroupAction(context, param) {
    const res = await deleteGoodsRelationGroupApi(param)
    return res
  },
  //  添加商品搭售关联配置
  async addGoodsRelationConfigAction(context, param) {
    const res = await addGoodsRelationConfigApi(param)
    return res
  },
  //  修改商品搭售关联配置
  async updateGoodsRelationConfigAction(context, param) {
    const res = await updateGoodsRelationConfigApi(param)
    return res
  },
  //  根据detailId获取商品搭售关联配置详情
  async getGoodsRelationConfigDetailByIdAction(context, param) {
    const res = await getGoodsRelationConfigDetailByIdApi(param)
    return res
  },
  //  保存商品搭售关联配置vip价格
  async saveGoodsRelationConfigVipPriceAction(context, param) {
    const res = await saveGoodsRelationConfigVipPriceApi(param)
    return res
  },
  //  删除商品搭售关联配置
  async deleteGoodsRelationConfigAction(context, param) {
    const res = await deleteGoodsRelationConfigApi(param)
    return res
  },
  //  批量设置商品虚拟销量
  async batchSetGoodsVirtualSalesNumAction(context, param) {
    const res = await batchSetGoodsVirtualSalesNumApi(param)
    return res
  },
  //  设置商品是否上架
  async setGoodsIsShelvesAction(context, param) {
    const res = await setGoodsIsShelvesApi(param)
    return res
  },
  //  批量设置商品是否上架
  async batchSetGoodsIsShelvesAction(context, param) {
    const res = await batchSetGoodsIsShelvesApi(param)
    return res
  },
  //  批量设置商品sku信息
  async batchSetGoodsSkuAction(context, param) {
    const res = await batchSetGoodsSkuApi(param)
    return res
  },
  //  设置商品图片
  async setGoodsPicContentAction(context, param) {
    const res = await setGoodsPicContentApi(param)
    return res
  },
  //  查询商品列表信息
  async queryGoodsAction(context, param) {
    const res = await queryGoodsApi(param)
    return res
  },
  //  查询商品列表信息
  async updateGoodsSkuAction(context, param) {
    const res = await updateGoodsSkuApi(param)
    return res
  },
  //  获取品牌下门店列表所在城市
  async getShopCityListByBrandIdAction(context, param) {
    const res = await getShopCityListByBrandIdApi(param)
    return res
  },
  //  获取品牌下门店列表
  async queryShopAction(context, param) {
    const res = await queryShopApi(param)
    return res
  },
  //  获取商品搭售分组和对应配置统计列表
  async getGoodsRelationGroupAndConfigCountListAction(context, param) {
    const res = await getGoodsRelationGroupAndConfigCountListApi(param)
    return res
  },
  //  获取商品搭售关联配置详情列表
  async getGoodsRelationConfigDetailListAction(context, param) {
    const res = await getGoodsRelationConfigDetailListApi(param)
    return res
  },
  //  查询商品标签信息
  async queryGoodsTagAction(context, param) {
    const res = await queryGoodsTagApi(param)
    return res
  },
  //  查询商品详情模板信息
  async queryGoodsDetailsTemplateAction(context, param) {
    const res = await queryGoodsDetailsTemplateApi(param)
    return res
  },
  //  商品类型排序
  async setGoodsTypeSortNumAction(context, param) {
    const res = await setGoodsTypeSortNumApi(param)
    return res
  },
  //  保存sku图片编号
  async saveSkuPicAction(context, param) {
    const res = await saveSkuPicApi(param)
    return res
  },
  //  更新商品是否在详情页展示
  async updateGoodsIsShowedInDetailAction(context, param) {
    const res = await updateGoodsIsShowedInDetailApi(param)
    return res
  },
  //  设置商品搭售关联配置排序
  async setGoodsRelationConfigSortAction(context, param) {
    const res = await setGoodsRelationConfigSortApi(param)
    return res
  },
  //  获取商品搭售分组列表
  async getGoodsRelationGroupListAction(context, param) {
    const res = await getGoodsRelationGroupListApi(param)
    return res
  },
  //  添加商品搭售分组关联
  async addGoodsRelationGroupRelAction(context, param) {
    const res = await addGoodsRelationGroupRelApi(param)
    return res
  },
  //  删除商品搭售分组关联
  async deleteGoodsRelationGroupRelAction(context, param) {
    const res = await deleteGoodsRelationGroupRelApi(param)
    return res
  },
  //  获取商品详情列表信息
  async getGoodsDetailListAction(context, param) {
    const res = await getGoodsDetailListApi(param)
    return res
  },
  //  发布商品模板
  async addGoodsTemplateAction(context, param) {
    const res = await addGoodsTemplateApi(param)
    return res
  },
  //  商品模板引用
  async goodsTemplateQuoteAction(context, param) {
    const res = await goodsTemplateQuoteApi(param)
    return res
  },
  //  商品模板图片引用
  async goodsTemplatePicQuoteAction(context, param) {
    const res = await goodsTemplatePicQuoteApi(param)
    return res
  },
  //  查询对应品牌发布的商品数量
  async getBrandGoodsTemplateCountAction(context, param) {
    const res = await getBrandGoodsTemplateCountApi(param)
    return res
  },
  //  查询商品模板列表信息
  async queryGoodsTemplateAction(context, param) {
    const res = await queryGoodsTemplateApi(param)
    return res
  },
  //  根据id查询商品模板
  async getGoodsTemplateByIdAction(context, param) {
    const res = await getGoodsTemplateByIdApi(param)
    return res
  },
  //  删除商品模板
  async deleteGoodsTemplateAction(context, param) {
    const res = await deleteGoodsTemplateApi(param)
    return res
  },
  //  查询商品列表(用于选择商品)
  async queryGoodsListAction(context, param) {
    const res = await queryGoodsListApi(param)
    return res
  },
  //  添加商品模板用于供应商品
  async addGoodsTemplateForSupplyAction(context, param) {
    const res = await addGoodsTemplateForSupplyApi(param)
    return res
  },
  //  查询商品模板用于供应商品
  async queryGoodsTemplateForSupplyAction(context, param) {
    const res = await queryGoodsTemplateForSupplyApi(param)
    return res
  },
  //  设置商品模板是否上架
  async setGoodsTemplateIsShelvesAction(context, param) {
    const res = await setGoodsTemplateIsShelvesApi(param)
    return res
  },
  //  一键代售添加商品
  async onekeyAgentSaleAddGoodsAction(context, param) {
    const res = await onekeyAgentSaleAddGoodsApi(param)
    return res
  },
  //  根据id获取商品模板用于供应商商品
  async getGoodsTemplateForSupplyByIdAction(context, param) {
    const res = await getGoodsTemplateForSupplyByIdApi(param)
    return res
  },
  //  更新商品模板用于供应商商品
  async updateGoodsTemplateForSupplyAction(context, param) {
    const res = await updateGoodsTemplateForSupplyApi(param)
    return res
  },
  //  更新海报商品接口
  async updatePosterGoodsAction(context, param) {
    const res = await updatePosterGoodsApi(param)
    return res
  },
  //  获得海报商品接口
  async getPosterGoodsAction(context, param) {
    const res = await getPosterGoodsApi(param)
    return res
  },
  //  添加门店商品类型信息
  async addShopGoodsTypeAction(context, param) {
    const res = await addShopGoodsTypeApi(param)
    return res
  },
  //  获取门店商品类型列表
  async getShopGoodsTypeListAction(context, param) {
    const res = await getShopGoodsTypeListApi(param)
    return res
  },
  //  添加门店商品信息
  async addShopGoodsAction(context, param) {
    const res = await addShopGoodsApi(param)
    return res
  },
  //  更新门店商品信息
  async updateShopGoodsAction(context, param) {
    const res = await updateShopGoodsApi(param)
    return res
  },
  //  添加门店商品sku信息
  async addShopGoodsSkuAction(context, param) {
    const res = await addShopGoodsSkuApi(param)
    return res
  },
  //  更新门店商品sku
  async updateShopGoodsSkuAction(context, param) {
    const res = await updateShopGoodsSkuApi(param)
    return res
  },
  //  添加门店商品搭售关联配置
  async addShopGoodsRelationConfigAction(context, param) {
    const res = await addShopGoodsRelationConfigApi(param)
    return res
  },
  //  修改门店商品搭售关联配置
  async updateShopGoodsRelationConfigAction(context, param) {
    const res = await updateShopGoodsRelationConfigApi(param)
    return res
  },
  //  批量设置门店商品sku信息
  async batchSetShopGoodsSkuAction(context, param) {
    const res = await batchSetShopGoodsSkuApi(param)
    return res
  },
  //  批量导入外部商品码
  async batchImportOutGoodsCodeAction(context, param) {
    const res = await batchImportOutGoodsCodeApi(param)
    return res
  },
  //  查询商品码
  async queryGoodsCodeAction(context, param) {
    const res = await queryGoodsCodeApi(param)
    return res
  },
  //  删除商品码
  async deleteGoodsCodeAction(context, param) {
    const res = await deleteGoodsCodeApi(param)
    return res
  },
  //  设置商品是否推荐
  async setGoodsIsRecomAction(context, param) {
    const res = await setGoodsIsRecomApi(param)
    return res
  },
  //  设置商品限购规则
  async setGoodsLimitBuyRuleAction(context, param) {
    const res = await setGoodsLimitBuyRuleApi(param)
    return res
  },
  //  获取限购商品id集
  async getLimitBuyGoodsIdsAction(context, param) {
    const res = await getLimitBuyGoodsIdsApi(param)
    return res
  },
  //  批量拷贝门店商品
  async batchCopyShopGoodsAction(context, param) {
    const res = await batchCopyShopGoodsApi(param)
    return res
  },
  // 小程序请求商品列表
  async getGoodsByGoodsTypeIdAction(context, param) {
    const res = await getGoodsByGoodsTypeIdApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
